export default __webpack_public_path__ + "static/media/boy-2.51837138.png";